const MERCHANTVIEW_API_BE = 'https://merchant.vietinbank.vn/';

// const MERCHANTVIEW_API_BE = 'http://10.122.119.161:8020/';

/// uat

// const MERCHANTVIEW_API_BE = 'http://10.6.145.186:6003/';

export default {
  MERCHANTVIEW_API_BE,
};
